import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import PerPageOptions from "./PerPageOptions";
import CurrentItemsLabel from "./CurrentItemsLabel";

const TotalItemsCountLabel = ({ numItems, itemsType }) => {
  return (
    <Typography variant="h6" color="textSecondary">{`${
      numItems ? numItems : ""
    } ${itemsType}`}</Typography>
  );
};

export default function PaginationHeader(props) {
  const {
    numPerPageOptions,
    numItemsPerPage,
    numItems,
    itemsType,
    currentPage,
    onPerPageChange,
    showTotalResults
  } = props;
  return (
    <>
      <Box
        data-qa="pagination-header"
        display="flex"
        alignItems="center"
        flex={1}
      >
        <CurrentItemsLabel
          numItems={numItems}
          numItemsPerPage={numItemsPerPage}
          currentPage={currentPage}
        />
        <PerPageOptions
          numPerPageOptions={numPerPageOptions}
          numItemsPerPage={numItemsPerPage}
          onPerPageChange={onPerPageChange}
        />
      </Box>
      {showTotalResults && (
        <Box
          display={{ xs: "none", sm: "flex" }}
          justifyContent="center"
          flex={1}
        >
          <TotalItemsCountLabel numItems={numItems} itemsType={itemsType} />
        </Box>
      )}
    </>
  );
}

PaginationHeader.propTypes = {
  onPerPageChange: PropTypes.func,
  currentPage: PropTypes.number,
  itemsType: PropTypes.string,
  numItems: PropTypes.number,
  numItemsPerPage: PropTypes.string,
  numPerPageOptions: PropTypes.arrayOf(PropTypes.string),
  showTotalResults: PropTypes.bool
};

PaginationHeader.defaultProps = {
  showTotalResults: true
};
